import { render, staticRenderFns } from "./MedicinesTypesTable.vue?vue&type=template&id=7c863774&"
import script from "./MedicinesTypesTable.vue?vue&type=script&lang=js&"
export * from "./MedicinesTypesTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports